import { FormattedMessage } from "react-intl";

import { intl } from "./TranslationProvider";
import { isShowTranslationKey } from "./utils/showTranslationKey";

export function t(
  translationKey: string,
  values?: Record<string, string | number | undefined | null>
) {
  if (isShowTranslationKey() || !intl) {
    return translationKey;
  }

  return intl.formatMessage({ id: translationKey }, values);
}

interface Props {
  translationKey: string;
  values?: Record<string, string | number | undefined | null>;
}

export const T = ({ translationKey, values }: Props) => {
  if (isShowTranslationKey()) {
    return <>{translationKey}</>;
  }

  return <FormattedMessage id={translationKey} values={values} />;
};
